export const isPayrollAccessError = (
  error: unknown,
): error is { status: 401 | 403 | 404 } => {
  if (!error || typeof error !== "object") return false;
  const status = "status" in error ? error.status : undefined;
  return status === 401 || status === 403 || status === 404;
};
